import React from "react";
import { ContentBuilder } from "@redriver/cinnamon";
import { Image } from "semantic-ui-react";
import { ContentPanel } from "components/displays";
import { withPermissions } from "features/../../../shared/components/auth";
import AgreementCoverUploadModal from "./AgreementCoverUploadModal";
import {
  uploadMasterDocCover,
  uploadRewriteDocCover,
  GetMasterDocCover,
  GetRewriteDocCover,
} from "../actions";

const AgreementCovers = ({ dealerId }) => {
  return (
    <ContentPanel
      title="Agreement Front Covers"
      wrapperCssClass="outline-grid dealers-details"
      headerCssClass="defaults-page-title"
    >
      <ContentBuilder
        loadAction={GetMasterDocCover}
        loadParams={dealerId}
        renderContent={(data, state, events) => (
          <div className="cover-upload-container">
            <div className="upload-button-wrapper">
              <AgreementCoverUploadModal
                triggerText="Upload master document front cover"
                modalHeader="Upload master document front cover"
                dealerId={dealerId}
                submitAction={uploadMasterDocCover}
                onSubmitted={events.onReset}
              />
            </div>
            <div className="image-preview-placeholder">
              {data ? (
                <Image
                  src={data}
                  alt="Master document front cover"
                  className="cover-image-preview"
                />
              ) : (
                <span>Image Preview</span>
              )}
            </div>
          </div>
        )}
      />
      <ContentBuilder
        loadAction={GetRewriteDocCover}
        loadParams={dealerId}
        renderContent={(data, state, events) => (
          <div className="cover-upload-container">
            <div className="upload-button-wrapper">
              <AgreementCoverUploadModal
                triggerText="Upload Rewrite document front cover"
                modalHeader="Upload Rewrite document front cover"
                dealerId={dealerId}
                submitAction={uploadRewriteDocCover}
                onSubmitted={events.onReset}
              />
            </div>
            <div className="image-preview-placeholder">
              {data ? (
                <Image
                  src={data}
                  alt="Rewrite document front cover"
                  className="cover-image-preview"
                />
              ) : (
                <span>Image Preview</span>
              )}
            </div>
          </div>
        )}
      />
    </ContentPanel>
  );
};

export default withPermissions(AgreementCovers);
